<template>
  <div class="share">
    <div class="share-loading" v-if="!showRedpacket"><span>正在加载中
      <br>请稍后</span>
    </div>
    <div class="share-container">
      <Header :inShare="true"></Header>
      <Redpacket
        v-if="showRedpacket"
        :inApp="false"
        :inShare="true"
        :isActivate="isActivate"
        :isFinish="isFinish"
        :isHelp="isHelp"
        :isValid="isValid"
        :isOwn="isOwn"
        :hasHelpRedpacket="hasHelpRedpacket"
        :random_price="random_price"
        :hasPhone="hasPhone"
        @isHelp="helpTrue"
        @close="getWxRp"
      ></Redpacket>
      <FriendRank class="friendRank" :hasFriendHelped="hasFriendHelped" :help_users="help_users"></FriendRank>
      <div class="share-footer"></div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import FriendRank from '@/components/FriendRank.vue';
import Redpacket from '@/components/Redpacket.vue';
import api from '@/api/api';

export default {
  name: 'share',
  components: {
    Header,
    FriendRank,
    Redpacket
  },
  data() {
    return {
      code: '',
      showHelp: false,
      hasFriendHelped: false,
      hasHelpRedpacket: false,
      isActivate: false,
      isFinish: false,
      isHelp: false,
      isValid: false,
      rp_id: '',
      random_price: 0,
      isOwn: false,
      help_users: [],
      showRedpacket: false,
      hasPhone: false
    };
  },
  computed: {},
  mounted() {
    console.log('Share.vue mounted');
    this.rp_id = this.$route.query.rpId;
    this.getWxRp();
  },
  methods: {
    helpTrue() {
      this.isHelp = true;
      this.getWxRp();
    },
    getWxRp() {
      api
        .getWxRp({ rp_id: this.rp_id })
        .then(res => {
          if (res.ok) {
            console.log('wx rp', res);
            if (res.result.help_users.length > 0) {
              this.hasFriendHelped = true;
            }
            this.help_users = res.result.help_users;
            this.random_price = res.result.random_price;
            this.isActivate = res.result.is_activate;
            this.isFinish = res.result.is_finish;
            this.isHelp = res.result.is_help;
            this.isValid = res.result.is_valid;
            this.isOwn = res.result.is_own;
            this.showRedpacket = true;
          }
        })
        .catch(err => {
          window.Sentry && window.Sentry.captureException(err);
          alert(err.message);
        });
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/index.scss';
.share {
  @include set-image('../assets/images/home-bg1.jpg');
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  &-container {
    @include set-size(750, 1182);
    position: relative;
  }
  &-loading {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50vw;
    height: 20vw;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.4);
    color: #ffffff;
    z-index: 999;
    line-height: 1.6em;
  }
  .friendRank {
    @include set-lt(0, 1002);
    width: 100vw;
    z-index: 10;
  }
  &-footer {
    @include set-image('../assets/images/home-footer.png');
    @include set-size(750, 904);
    @include set-rb(0, -240);
  }
}

@media (min-aspect-ratio: 750/1182) {
  .share {
    &-container {
      @include set-image('../assets/images/home-bg1.jpg');
      height: 100%;
    }
    &-footer {
      @include set-image('../assets/images/home-footer.png');
      @include set-size(750, 640);
      @include set-rb(0, 0);
    }
    .friendRank {
      @include set-lt(0, 858);
      width: 100vw;
      z-index: 10;
    }
  }
}
</style>